import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import useSidebarContext from 'common/hooks/context/useSidebarContext';

const useStyles = makeStyles(() => ({
  sidebarTooltipContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
}));

interface ISidebarTooltip {
  title: string;
}

const SidebarTooltip: FC<ISidebarTooltip> = ({ title }) => {
  const classes = useStyles();
  const { sidebarOpen } = useSidebarContext();

  return (
    <Tooltip
      title={title}
      disableFocusListener={sidebarOpen}
      disableHoverListener={sidebarOpen}
      disableTouchListener={sidebarOpen}
      enterDelay={100}
    >
      <div className={classes.sidebarTooltipContainer} />
    </Tooltip>
  );
};

export default SidebarTooltip;
